/*
 * TODO: I couldn't found starknet in caip
 * @see https://namespaces.chainagnostic.org/
 */

// if the value needs to be change make sure you will update mapCaipNamespaceToLegacyNetworkName as well
export const CAIP_NAMESPACE = 'starknet';
export const CAIP_STARKNET_CHAIN_ID = 'SN_MAIN';
